import { HTTP } from '../../utils/http';

export const TShirtsService = {

    getTShirts(schoolId) {
        return HTTP.get(`schools/${schoolId}/settings/t-shirt-sizes`);
    },

    getAllTShirts(schoolId) {
        return HTTP.get(`schools/${schoolId}/settings/t-shirt-sizes/all-active`);
    },

    toggleTShirtStatusStatus(schoolId, sizeId) {
        return HTTP.patch(`schools/${schoolId}/settings/t-shirt-sizes/${sizeId}`);
    },

    migrateChildren(schoolId, form) {
        return HTTP.put(`schools/${schoolId}/settings/t-shirt-sizes`, form);
    }
};


// WEBPACK FOOTER //
// ./src/common/services/settings/t-shirts.service.js